import React, { useState } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

const FormComponent = ({ formData, setFormData, handleSubmit, errors, setErrors, handleChange }) => {
    const [showPass, setShowPass] = useState(false)
    return (
        <form className="px-[35px] ">
            <div className="mb-4">
                <label className="block text-[16px] font-medium my-[14px] font-mont text-[#1B2A3D]">App ID</label>
                <input
                    type="text"
                    name="appId"
                    value={formData.appId}
                    onChange={handleChange}
                    className="w-full p-2 border border-[#667788] rounded"
                />
                {errors.appId && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{errors.appId}</p>}
            </div>
            <div className="">
                <label className="block text-[16px] font-medium my-[14px] font-mont text-[#1B2A3D]">App Secret</label>
                <div className="flex relative"><input
                    type={showPass ? "text" : "password"}
                    name="appSecret"
                    value={formData.appSecret}
                    onChange={handleChange}
                    className="w-full p-2 border border-[#667788] rounded"
                /><div className="absolute right-2 top-3">
                        {showPass ? <FaRegEyeSlash className="w-5 hover:text-[#245CEA]" onClick={() => { setShowPass(!showPass) }} /> :

                            <FaRegEye className="w-5 hover:text-[#245CEA]" onClick={() => { setShowPass(!showPass) }} />
                        }
                    </div></div>

                {errors.appSecret && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{errors.appSecret}</p>}
            </div>

        </form>
    );
};

export default FormComponent;
